import { useTRPCClientAPI, useTRPCMutation } from '../../../../trpc/trpc';
import { useInvalidateOutreach } from './useInvalidateOutreach';

export interface ContactUpdate {
  workspaceContactUuid: string;
  tags?: string[];
  notes?: string | null;
  status?: 'doNotContact' | 'new';
}

/**
 * The contact writes: tags, notes, do not contact, and the CSV export (Pro and up). Outreach v2 has
 * no reveal and no pick of directory people (`contacts.reveal` and `contacts.addToWorkspace` are gone).
 */
export function useContactActions(accountId: number) {
  const trpcClient = useTRPCClientAPI();
  const invalidate = useInvalidateOutreach();

  const update = useTRPCMutation({
    mutationFn: (input: ContactUpdate) => trpcClient.outreach.contacts.update.mutate({ accountId, ...input }),
    onSuccess: () => invalidate(['contacts']),
  });
  const exportCsv = useTRPCMutation({
    mutationFn: (listUuid: string | null) => trpcClient.outreach.contacts.export.mutate({ accountId, listUuid }),
  });

  return {
    updateContact: update.mutateAsync,
    isUpdating: update.isPending,
    exportCsv: exportCsv.mutateAsync,
    isExporting: exportCsv.isPending,
  };
}
